module.exports = __webpack_public_path__ + "img/about-circle.0ac27e08.png";